type ConsentValue = "granted" | "denied";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const ensureGtagStub = (): void => {
  window.dataLayer = window.dataLayer ?? [];
  window.gtag =
    window.gtag ??
    ((...args: unknown[]) => {
      window.dataLayer?.push(args);
    });
};

/**
 * Sets Google Consent Mode v2 values.
 *
 * Note: For AdSense, the critical GDPR-safe behavior is still: do not load the
 * AdSense script until consent is accepted. Consent Mode is an additional signal.
 */
export const setAdsConsentMode = (value: ConsentValue): void => {
  ensureGtagStub();

  window.gtag?.("consent", "update", {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
  });
};

export const setDefaultAdsConsentMode = (): void => {
  ensureGtagStub();
  window.gtag?.("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    wait_for_update: 500,
  });
};
